<template>
    <main class="legal-page position-relative overflow-hidden">
        <img class="legal-page__corner position-absolute top-0 end-0" src="/img/svg/nav-corner-1.svg" alt="">

        <div class="container position-relative py-5">
            <header class="legal-page__header mx-auto text-center">
                <p class="legal-page__eyebrow mb-3">{{$t('marketing.misc.legal_kicker')}}</p>
                <h1 class="display-5 fw-bolder text-gray-900 mb-3">{{$t('marketing.misc.legal_entity')}}</h1>
                <p class="fs-5 text-gray-600 mb-0">{{$t('marketing.misc.legal_intro')}}</p>
            </header>

            <section class="legal-card mx-auto" :aria-label="$t('marketing.misc.legal_entity')">
                <dl class="legal-card__details mb-0">
                    <div class="legal-card__item legal-card__item--wide">
                        <dt>{{$t('marketing.misc.company_name')}}</dt>
                        <dd>TAPGIANT S.R.L.</dd>
                    </div>
                    <div class="legal-card__item">
                        <dt>{{$t('marketing.misc.tax_identifier')}}</dt>
                        <dd>45932721</dd>
                    </div>
                    <div class="legal-card__item">
                        <dt>{{$t('marketing.misc.trade_registry')}}</dt>
                        <dd>J22/1182/2022</dd>
                    </div>
                    <div class="legal-card__item">
                        <dt>{{$t('marketing.misc.address')}}</dt>
                        <dd><address class="mb-0">{{$t('marketing.misc.company_address')}}</address></dd>
                    </div>
                    <div class="legal-card__item">
                        <dt>{{$t('marketing.misc.inquiries')}}</dt>
                        <dd><a href="mailto:contact@tapgiant.com">contact[at]tapgiant.com</a></dd>
                    </div>
                </dl>
            </section>
        </div>
    </main>
</template>
